export default {
  props: {
		invert: {
			default: false,
			type: Boolean
		}
	},
	data () {
    return {
      sygnetColor: '#e94357'
    }
  },
	computed: {
		getColor () {
			return this.invert
				? '#000000'
				: '#ffffff'
		}
	}
}
